/**
 * Runs `fn` in a task after the next frame has painted. Use it for work an interaction
 * triggers that the visitor does not need to see in the same frame (analytics hooks, URL
 * updates, off-screen DOM rebuilds), so it does not count toward the tap's INP.
 * @param {() => void} fn
 */
export const afterNextPaint = (fn) => {
  requestAnimationFrame(() => setTimeout(fn, 0));
};
